import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const BarData = ({ Title, BarGraphData = [], onBarClick, className = "" }) => {
  const barWidth = 30;

  const handleBarClick = (name) => {
    if (!onBarClick) return;

    if (name === "<$1M" || name === "$1M-$3M" || name === ">$3M") {
      const key =
        name === "<$1M"
          ? "less_than_1m"
          : name === "$1M-$3M"
          ? "between_1m_3m"
          : "greater_than_3m";
      onBarClick(key);
    } else if (name === "Buyer" || name === "Disposition") {
      const leadType = name === "Buyer" ? "acquisition" : "disposition";
      onBarClick(leadType);
    } else {
      const key = BarGraphData.find((item) => item.name === name)?.key;
      if (key) onBarClick(key);
    }
  };

  const renderCustomBar = (props) => {
    const { x, y, width, height, payload } = props;
    const color = payload?.active ? "#2D5B30" : "#BFD3C1";
    return (
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        fill={color}
        rx={4}
        ry={4}
        cursor="pointer"
        onClick={() => handleBarClick(payload.name)}
      />
    );
  };

  return (
    <div className={`light-bg-L h-full w-full p-4 flex flex-col justify-between ${className}`}>
      {/* Header */}
      <h2 className="head-2 dark-H text-center mb-4">
        {typeof Title === "string" ? Title : "Type of Lead"}
      </h2>

      {/* Chart Container */}
      <div className="relative w-full" style={{ height: "300px" }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={BarGraphData}
            margin={{ top: 10, right: 20, left: 0, bottom: 10 }}
            barCategoryGap="30%"
          >
            <CartesianGrid stroke="#efefef" vertical={false} />
            <XAxis
              dataKey="name"
              axisLine={false}
              tickLine={false}
              tickMargin={10}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              tickFormatter={(value) => {
                if (value >= 1_000_000_000) return (value / 1_000_000_000).toFixed(1) + "B";
                if (value >= 1_000_000) return (value / 1_000_000).toFixed(1) + "M";
                if (value >= 1_000) return (value / 1_000).toFixed(1) + "K";
                return value.toLocaleString();
              }}
            />
            <Tooltip formatter={(value) => [`${Number(value).toLocaleString()}`]} />
            <Bar
              dataKey="count"
              shape={renderCustomBar}
              barSize={barWidth}
              onClick={(data) => handleBarClick(data.name)}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default BarData;
